const PERSIAN_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

export function toEnglishDigits(value: string): string {
  return value.replace(/[۰-۹]/g, (digit) => String(PERSIAN_DIGITS.indexOf(digit)));
}

export function toPersianDigits(value: string | number): string {
  return String(value).replace(/\d/g, (digit) => PERSIAN_DIGITS[Number(digit)]);
}

export function formatPhoneDisplay(phone: string): string {
  const normalized = toEnglishDigits(phone).replace(/\D/g, "");
  if (normalized.length !== 11) return toPersianDigits(normalized);

  return toPersianDigits(
    `${normalized.slice(0, 4)} ${normalized.slice(4, 7)} ${normalized.slice(7)}`,
  );
}

export function formatOtpTimer(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formatted = `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;

  return toPersianDigits(formatted);
}
